import { NavLink, useLocation } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard,
  Users,
  ClipboardCheck,
  Wallet,
  HeartHandshake,
  PieChart,
  FileText,
  UserCircle,
} from 'lucide-react';

interface NavItem {
  path: string;
  label: string;
  icon: React.ElementType;
  roles?: string[];
}

export default function BottomNav() {
  const location = useLocation();
  const { userRole } = useAppStore();

  const navItems: NavItem[] = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/members', label: 'Members', icon: Users, roles: ['admin', 'treasurer', 'secretary'] },
    { path: '/attendance', label: 'Attendance', icon: ClipboardCheck, roles: ['admin', 'treasurer', 'secretary'] },
    { path: '/dues', label: 'Dues', icon: Wallet, roles: ['admin', 'treasurer', 'secretary'] },
    { path: '/donations', label: 'Donations', icon: HeartHandshake, roles: ['admin', 'treasurer', 'secretary'] },
    { path: '/finances', label: 'Finances', icon: PieChart, roles: ['admin', 'treasurer'] },
    { path: '/my-record', label: 'My Record', icon: FileText },
    { path: '/profile', label: 'Profile', icon: UserCircle },
  ];

  const filteredItems = navItems.filter(
    (item) => !item.roles || (userRole && item.roles.includes(userRole))
  );

  // Show max 5 items on mobile
  const visibleItems = filteredItems.slice(0, 5);

  return (
    <nav className="bg-background border-t safe-area-pb">
      <div className="flex items-center justify-around h-16">
        {visibleItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(`${item.path}/`);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                'flex flex-col items-center justify-center flex-1 h-full min-w-[60px] transition-colors',
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <item.icon className={cn('w-5 h-5 mb-1', isActive && 'stroke-[2.5px]')} />
              <span className="text-[10px] font-medium truncate max-w-[70px]">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
